import { render, staticRenderFns } from "./HuaiHuaInfo.vue?vue&type=template&id=3c3bf993&scoped=true&"
import script from "./HuaiHuaInfo.vue?vue&type=script&lang=js&"
export * from "./HuaiHuaInfo.vue?vue&type=script&lang=js&"
import style0 from "./HuaiHuaInfo.vue?vue&type=style&index=0&id=3c3bf993&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3bf993",
  null
  
)

export default component.exports